/**
 * DEC-001: Shopify-style Experience View for Storefront Page Config DocType
 * 
 * This view enables Experience mode for Storefront Page Config.
 * The actual layout is driven by DocViewSchema (storefrontPageConfig.ts).
 */

import type { DocTypeView } from '../types';

export const storefrontPageConfigShopifyView: DocTypeView = {
  id: 'storefront-page-config-shopify-v1',
  doctype: 'Storefront Page Config',
  style: 'shopify',
  context: undefined,
  status: 'active',
  label: 'Storefront Page Config – Shopify Style',
  description: 'Shopify-style layout for Storefront Page Config detail page',
  formView: {
    sections: [], // Layout driven by DocViewSchema
    customFieldBucket: {
      enabled: false, // Builder widget handles all fields
    },
  },
  createdBy: 'system',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
